import PUBLIC_PAGE_STATUS from 'constants/publicPage';
import { IPublicPageDocumentStructure } from 'types/PublicPage';

const getIsEveryDocumentsDone = (documents: IPublicPageDocumentStructure[]) => (
  documents.every((document) => (
    document.status === PUBLIC_PAGE_STATUS.DONE
  ))
);

export default getIsEveryDocumentsDone;